// If you modify this, please also update ./check-polyfills.js

require('core-js/features/array/find')
require('core-js/features/array/from')
require('core-js/features/array/includes')
require('core-js/features/object/assign')
require('core-js/features/object/entries')
require('core-js/features/object/values')
require('core-js/features/string/ends-with')
require('core-js/features/string/includes')
require('core-js/features/string/starts-with')
require('core-js/features/symbol')

if (process.env.NODE_TARGET === 'web') {
  const isIE11 = window && window.navigator.userAgent.includes('Trident/')

  if (isIE11 || typeof Promise === 'undefined' || !('finally' in Promise.prototype)) {
    require('promise/lib/rejection-tracking').enable()
    self.Promise = require('promise/lib/es6-extensions.js')
  }
}

if (process.env.NODE_TARGET === 'web') {
  require('abortcontroller-polyfill/dist/abortcontroller-polyfill-only')
  require('cross-fetch/polyfill')
} else {
  if (typeof fetch === 'undefined') {
    const nodeFetch = require('@tigerconnect/node-fetch')
    global.fetch = nodeFetch.default
    global.Headers = nodeFetch.Headers
    global.Request = nodeFetch.Request
    global.Response = nodeFetch.Response

    require('abortcontroller-polyfill/dist/polyfill-patch-fetch')
  }
}
